module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "video-wrapper"
  }, [_c('div', {
    staticClass: "mainscreen-pull",
    class: {
      'mainscreen-pull--hidden': !_vm.hasPullUrl
    }
  }, [_c('video', {
    staticClass: "zb-video",
    staticStyle: {
      "object-fit": "cover"
    },
    attrs: {
      "id": _vm.playerId,
      "preload": "auto",
      "playsinline": "",
      "webkit-playsinline": ""
    }
  }), _vm._v(" "), (!_vm.isPlaying) ? _c('div', {
    staticClass: "mainscreen-video-cover"
  }, [_c('div', {
    staticClass: "mainscreen-video-cover-box"
  }, [_c('img', {
    staticClass: "mainscreen-video-cover-img",
    attrs: {
      "src": _vm.mainScreenData && _vm.mainScreenData.userInfo && _vm.mainScreenData.userInfo.headPortrait,
      "alt": ""
    }
  })])]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.hasPullUrl),
      expression: "!hasPullUrl"
    }],
    staticClass: "mainscreen-bg"
  }, [_c('img', {
    staticClass: "mainscreen-bg-img",
    attrs: {
      "src": _vm.mainScreenData && _vm.mainScreenData.userInfo && _vm.mainScreenData.userInfo.headPortrait,
      "alt": ""
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c5620b7e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainscreenplayer/mainscreenplayer.vue
// module id = 1051
// module chunks = 1